export const getListItemToToggle = category => {
  switch (category) {
    // case 'black-friday-sale': // For Custom Category Page (LEAVE ONE EXAMPLE)
    // case 'sparkling-sale':
    // case 'flash-sale':
    case 'wine': // Standard Navigation
    case 'wine-red':
    case 'wine-white':
    case 'wine-sparkling':
    case 'wine-rose':
    case 'wine-best-selling':
    case 'mixed-packs':
    case 'pride-promo':
      return 'wine';
    case 'wine-collection-limited':
    case 'wine-collection-award-winning':
    case 'wine-glitter':
    case 'wine-collection-core':
    case 'wine-collection-vintner':
    case 'wine-collection-reserve':
    case 'wine-collection-iconic':
    case 'wine-collection-estate':
    case 'wine-collection-signature':
    case 'wine-collection-mixed':
      return 'collection';
    case 'valentines-day':
    case 'gift':
    case 'gift-marketplace':
    case 'gift-non-alcoholic':
    case 'gift-swag':
    case 'gift-wine':
    case 'gift-wine-accessories':
    case 'gifts':
    case 'gifts-best-selling':
    case 'coffee':
    case 'kitchen':
      return 'gift';
    case 'none': // TODO remove when category is separated from filter setting on custom category page
    case 'guide-for-moms':
    case 'guide-for-pet-lovers':
    case 'guide-for-teachers':
    case 'guide-for-guys':
    case 'guide-for-gals':
    case 'guide-for-cabernet':
    case 'guide-for-the-host':
      return 'guide';
    default:
      return 'wine';
  }
};

export const getFilterSelection = pathname => {
  switch (pathname) {
    default:
    case '/shop/wine/wine':
    case '/shop/wine/wine-glitter':
    case '/shop/wine/wine-collection-core':
    case '/shop/wine/wine-collection-vintner':
    case '/shop/wine/wine-collection-reserve':
      return 'type';
    case '/shop/wine/wine-red':
    case '/shop/wine/wine-white':
      return 'varietal';
    case '/shop/wine/wine-sparkling':
    case '/shop/wine/wine-rose':
    case '/shop/wine/wine-collection-iconic':
    case '/shop/wine/wine-collection-estate':
    case '/shop/wine/wine-collection-signature':
    case '/shop/wine/wine-collection-mixed':
      return 'cause';
    case '/shop/gifts/gift':
    case '/shop/gifts/gift-marketplace':
    case '/shop/gifts/gift-non-alcoholic':
    case '/shop/gifts/gift-swag':
    case '/shop/gifts/gift-wine':
    case '/shop/gifts/gift-wine-accessories':
    case '/shop/gifts/gifts':
      return 'giftCategories';
  }
};

const checkCategoryURL = pathname => {
  switch (true) {
    case pathname.includes('coffee'):
      return 'coffee';
    case pathname.includes('kitchen'):
      return 'kitchen';
    case pathname.includes('box'):
    case pathname.includes('gift'):
    case pathname.includes('crate'):
      return 'gift';
    case pathname.includes('marketplace'):
      return 'gift-marketplace';
    case pathname.includes('wine-accessory'):
      return 'gift-wine-accessories';
    case pathname.includes('swag'):
      return 'gift-swag';
    case pathname.includes('guide'):
      return 'guide';
    default:
      return 'wine';
  }
};

export const getCategory = pathname => {
  if (pathname.includes('shop/product')) {
    return checkCategoryURL(pathname);
  }
  switch (pathname) {
    case '/shop/wine/wine':
      return 'wine';
    case '/shop/wine/wine-red':
      return 'wine-red';
    case '/shop/wine/wine-white':
      return 'wine-white';
    case '/shop/wine/wine-sparkling':
      return 'wine-sparkling';
    case '/shop/wine/wine-rose':
      return 'wine-rose';
    case '/shop/wine/wine-collection-limited':
      return 'wine-collection-limited';
    case '/shop/wine/wine-collection-award-winning':
      return 'wine-collection-award-winning';
    case '/shop/wine/wine-glitter':
      return 'wine-glitter';
    case '/shop/wine/wine-collection-core':
      return 'wine-collection-core';
    case '/shop/wine/wine-collection-vintner':
      return 'wine-collection-vintner';
    case '/shop/wine/wine-collection-reserve':
      return 'wine-collection-reserve';
    case '/shop/wine/wine-collection-iconic':
      return 'wine-collection-iconic';
    case '/shop/wine/wine-collection-estate':
      return 'wine-collection-estate';
    case '/shop/wine/wine-collection-signature':
      return 'wine-collection-signature';
    case '/shop/wine/wine-collection-mixed':
      return 'wine-collection-mixed';
    case '/shop/gifts/gift':
      return 'gift';
    case '/shop/gifts/gift-wine':
      return 'gift-wine';
    case '/shop/gifts/gifts':
      return 'gifts';
    case '/shop/gifts/gift-marketplace':
      return 'gift-marketplace';
    case '/shop/gifts/gift-non-alcoholic':
      return 'gift-non-alcoholic';
    case '/shop/gifts/gift-swag':
      return 'gift-swag';
    case '/shop/gifts/gift-wine-accessories':
      return 'gift-wine-accessories';
    case '/shop/coffee/coffee':
      return 'coffee';
    case '/shop/kitchen/kitchen':
      return 'kitchen';
    case '/shop/guide-for-gals':
    case '/shop/guide-for-guys':
    case '/shop/guide-for-pet-lovers':
    case '/shop/guide-for-teachers':
    case '/shop/guide-for-the-host':
      return 'guide';
    case '/shop/wine/wine-brut':
      return 'wine-brut';
    case '/shop/wine/wine-cabernet':
      return 'wine-cabernet';
    case '/shop/wine/wine-chardonnay':
      return 'wine-chardonnay';
    case '/shop/wine/wine-dessert':
      return 'wine-dessert';
    case '/shop/wine/wine-fume-blanc':
      return 'wine-fume-blanc';
    case '/shop/wine/wine-malbec':
      return 'wine-malbec';
    case '/shop/wine/wine-merlot':
      return 'wine-merlot';
    case '/shop/wine/wine-prosecco':
      return 'wine-prosecco';
    case '/shop/wine/wine-muscat-canelli':
      return 'wine-muscat-canelli';
    case '/shop/wine/wine-pinot-grigio':
      return 'wine-pinot-grigio';
    case '/shop/wine/wine-pinot-noir':
      return 'wine-pinot-noir';
    case '/shop/wine/wine-red-blend':
      return 'wine-red-blend';
    case '/shop/wine/wine-riesling':
      return 'wine-riesling';
    case '/shop/wine/wine-sauvignon-blanc':
      return 'wine-sauvignon-blanc';
    case '/shop/wine/wine-symphony':
      return 'wine-symphony';
    case '/shop/wine/wine-syrah':
      return 'wine-syrah';
    case '/shop/wine/wine-viognier':
      return 'wine-viognier';
    case 'shop/wine/wine-zinfandel':
      return 'wine-zinfandel';
    default:
      return 'wine';
  }
};

export const setFilterSelection = (pathname, filterSelection) => {
  switch (pathname) {
    case '/shop/wine/wine':
      return filterSelection !== 'giftCategories' ? filterSelection : 'type';
    case '/shop/wine/wine-red':
      return filterSelection !== 'giftCategories' && filterSelection !== 'type'
        ? filterSelection
        : 'varietal';
    case '/shop/wine/wine-white':
      return filterSelection !== 'giftCategories' && filterSelection !== 'type'
        ? filterSelection
        : 'varietal';
    case '/shop/wine/wine-sparkling':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/wine/wine-rose':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/wine/wine-glitter':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/wine/wine-collection-core':
    case '/shop/wine/wine-collection-vintner':
    case '/shop/wine/wine-collection-reserve':
      return filterSelection !== 'giftCategories' ? filterSelection : 'type';
    case '/shop/wine/wine-collection-iconic':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/wine/wine-collection-signature':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/wine/wine-collection-limited':
    case '/shop/wine/wine-collection-award-winning':
    case '/shop/wine/wine-collection-mixed':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/gifts/gift':
    case '/shop/gifts/gifts':
    case '/shop/gifts/gift-wine':
      return filterSelection !== 'type' && filterSelection !== 'varietal'
        ? filterSelection
        : 'giftCategories';
    case '/shop/gifts/gift-marketplace':
    case '/shop/gifts/gift-swag':
    case '/shop/gifts/gift-wine-accessories':
      return filterSelection !== 'type' &&
        filterSelection !== 'varietal' &&
        filterSelection !== 'cause'
        ? filterSelection
        : 'giftCategories';
    case '/shop/gifts/gift-non-alcoholic':
      return filterSelection !== 'giftCategories' &&
        filterSelection !== 'type' &&
        filterSelection !== 'varietal'
        ? filterSelection
        : 'cause';
    case '/shop/coffee/coffee':
    case '/shop/kitchen/kitchen':
      return '';
    default:
      return 'cause';
  }
};

export const getPathFromUrl = url => {
  return url.split('?')[0];
};
